module.exports = __webpack_public_path__ + "static/media/subaruoutlander2014on.afcd7156.jpg";